import { app } from 'cbmms-js/web';

export function relaunch(redirectURL) {
  const location = { pathname: '/launch' };

  if (!redirectURL) {
    redirectURL = app.getTopPage();
  }
  if (typeof redirectURL !== 'string') {
    redirectURL = app.stringifyLocation(redirectURL);
  }

  location.searchData = { 'CB-URL': redirectURL };

  return app.redirectTo(location);
}

export function gotoLogin(redirect) {
  const location = {
    pathname: '/login',
    searchData: { 'CB-URL': app.getTopPage() },
  };

  if (redirect) {
    return app.redirectTo(location);
  }

  return app.navigateTo(location);
}
